import { Row, Col } from "react-bootstrap";
import "./CVimage.css";
import { images } from "../../../../../constants/index";
import ProfileInformationCV from "../profileInformation4";
import CVProfileBio from "../CVProfileBio4";
import { getAsset } from "../../../../../helpers/helper";
import dummyezi from "../../../../../assets/images/dummy/dummyezi.png";

const CVImage = ({ cvdata }) => {
  return (

    <Row>
      <Col md={4} lg={4} xl={4} >
        <div>
          <div>
            <Col md={12} lg={12} className="p-0">
              <div className="img-4-Background">
                <img src={getAsset(cvdata?.profileInformation?.photo || cvdata?.user?.imageUrl)}
                  onError={(e) => { e.target.onerror = null; e.target.src = dummyezi; }}
                  crossOrigin="anonymous" alt="" className="img-5-Background " />
              </div>
            </Col>

            <div className="profilescroll noscroll ps-4 ms-2">
              <ProfileInformationCV cvdata={cvdata} />
            </div>
          </div>
        </div>
      </Col>
      <Col md={8} lg={8} xl={8} className="pe-0 ps-0">
        <CVProfileBio cvdata={cvdata} />
      </Col>
    </Row>

  );
};
export default CVImage;
